export default "__VITE_ASSET__8d9cc7f3__"